import isObject from 'lodash/isObject';
import { css, FlattenSimpleInterpolation } from 'styled-components';

import { media, VALID_BREAKPOINTS } from '../../../../../lib/StyledComponents';
import { VALID_BREAKPOINTS_WITH_BASE } from '../../../Theme/common';
import { VALID_BORDER_RADIUS_MEDIA_MAP } from '../calcBorderRadiusStyles';
import { calcBorderRadiusMediaShortHand } from '../calcBorderRadiusStyles.util';
import { VALID_EDGE_STYLE_KINDS, VALID_EDGE_STYLE_MEDIA_MAP } from '../calcEdgeStyles';

import { calcEdgeStyleMediaShortHand } from './calcEdgeStyleMediaShortHand';

const breakpointSortMap: Record<VALID_BREAKPOINTS_WITH_BASE, number> = {
  base: 0,
  xsmall: 1,
  small: 2,
  smallMedium: 3,
  medium: 4,
  mediumLarge: 5,
  large: 6,
  xlarge: 7,
  xxlarge: 8,
};

type VALID_CALC_MEDIA_MAP = VALID_BORDER_RADIUS_MEDIA_MAP | VALID_EDGE_STYLE_MEDIA_MAP;

export const calcMediaStyles = (
  mediaMap: VALID_CALC_MEDIA_MAP,
  kind: string,
): FlattenSimpleInterpolation[] => {
  const styles: FlattenSimpleInterpolation[] = [];
  const { base, ...pickedMediaMap } = mediaMap;

  // mobile first styles
  if (typeof base === 'string') {
    styles.push(css`
      ${kind}: ${base};
    `);
  }

  // captures edgesStyle base with shorthand usage ex: {base: {vertical: '3em'}}
  if (isObject(base) && VALID_EDGE_STYLE_KINDS.includes(kind)) {
    styles.push(calcEdgeStyleMediaShortHand(base, kind));
  }

  if (isObject(base) && kind === 'border-radius') {
    styles.push(calcBorderRadiusMediaShortHand(base));
  }

  const entries = Object.entries(pickedMediaMap);

  entries
    .sort((a, b) => breakpointSortMap[a[0] as VALID_BREAKPOINTS] - breakpointSortMap[b[0] as VALID_BREAKPOINTS])
    .forEach(([ breakpoint, style ]) => {
      if (typeof style === 'string') {
        styles.push(
          media[breakpoint as VALID_BREAKPOINTS]`
            ${kind}: ${style};
          `
        );
      }

      // captures edgesStyle breakpoint with shorthand usage ex: {large: {top: '3em'}}
      if (isObject(style) && VALID_EDGE_STYLE_KINDS.includes(kind)) {
        const shortHandStyles = calcEdgeStyleMediaShortHand(style, kind);

        styles.push(
          media[breakpoint as VALID_BREAKPOINTS]`
            ${shortHandStyles};
          `
        );
      }

      if (isObject(style) && kind === 'border-radius') {
        const shortHandStyles = calcBorderRadiusMediaShortHand(style);

        styles.push(
          media[breakpoint as VALID_BREAKPOINTS]`
            ${shortHandStyles};
          `
        );
      }
    });

  return styles;
};
